import { pxToRem } from '@/shared/styles/themes'
import { Checkbox, FormLabel, Grid2, Link, styled, Typography } from '@mui/material'

import { Button } from '../Button/Button'
import { Icon } from '../Icon/Icon'
import { SocialButton } from '../socialButton/socialButton'

export const StyledModalHeader = styled(Typography)`
  font-size: 20px;
  font-weight: 500;
  margin: 0;
`

export const StyledAltButton = styled(Button)`
  font-size: 14px;
  font-weight: 500;
  justify-self: center;
  color: ${(props) => props.theme.palette.text.primary};
  border: 1px solid ${(props) => props.theme.palette.text.primary};
  border-radius: 99px !important;
  height: 36px;
  display: none;

  &:hover {
    border: 1px solid ${(props) => props.theme.palette.text.primary};
    background-color: rgba(0, 0, 0, 0.1);
  }

  ${(props) => props.theme.breakpoints.up('sm')} {
    display: flex;
  }
`

export const StyledCloseButton = styled(Button)`
  font-size: 14px;
  font-weight: 500;
  justify-self: center;
  color: ${(props) => props.theme.palette.text.primary};
  border: 1px solid ${(props) => props.theme.palette.text.primary};
  border-radius: 99px !important;
  height: 36px;

  &:hover {
    border: 1px solid ${(props) => props.theme.palette.text.primary};
    background-color: rgba(0, 0, 0, 0.1);
  }

  ${(props) => props.theme.breakpoints.up('sm')} {
    display: none;
  }
`


export const StyledSocialButton = styled(SocialButton)`
  color: ${props => props.theme.palette.text.secondary};
  border-color: ${props => props.theme.palette.text.secondary};
`

export const StyledDivider = styled('div')`
  display: block;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  color: ${(props) => props.theme.palette.text.secondary};

  span {
    position: relative;
    display: inline-block;
  }

  span:before,
  span:after {
    content: "";
    position: absolute;
    top: 50%;
    width: 9999px;
    height: 1px;
    background: ${(props) => props.theme.palette.divider};
  }

  span:before {
    right: 100%;
    margin-right: 15px;
  }

  span:after {
    left: 100%;
    margin-left: 15px;
  }
`
export const StyledTextFieldLabel = styled(FormLabel)`
  display: block;
  font-size: ${(props) => props.theme.typography.pxToRem(14)};
  font-weight: 500;
  line-height: 1.5;
  margin: 0;
`

export const StyledCheckBox = styled(Checkbox)`
  margin-left: -10px;
`

export const StyledEyeIcon = styled(Icon)`
  font-size: 18px;
  margin: 0 6px;
`

export const StyledCheckBoxLabel = styled(FormLabel)`
  line-height: 1.4;
  font-size: 15px;
  font-weight: 300;
`

export const StyledCheckboxIcon = styled(Icon)`
  color: rgba(0, 0, 0, 0.2);
`

export const StyledInstructionSpan = styled(Typography)`
  font-weight: 300;
  font-size: 13px;
  line-height: 1.4;
`

export const StyledAltLink = styled(Link)`
  margin-left: 4px;
  color: ${(props) => props.theme.palette.primary.main};
  text-decoration: underline;
  cursor: pointer;
`

export const StyledLink = styled(Typography)`
  font-size: 13px;
  font-weight: 300;
  text-decoration: underline;
  cursor: pointer;
  color: ${(props) => props.theme.palette.text.secondary};

  &:hover {
    color: ${(props) => props.theme.palette.text.primary};
  }
`

export const StyledModalDescriptor = styled(Typography)`
  font-size: 16px;
  font-weight: 300;
  margin: 0;
  color: ${(props) => props.theme.palette.text.secondary};
`
export const StyledCaptchaContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: ${(props) => props.theme.typography.pxToRem(8)} 0;


  & > div {
    transform-origin: left top;
    
    ${props => props.theme.breakpoints.down('sm')} {
      transform: scale(0.85);
    }
  }
`
export const StyledForm = styled('form')`
  width: 100%;
`

export const StyledAdditionalGrid = styled(Grid2)`
  margin-top: ${pxToRem(16)};
  margin-bottom: ${pxToRem(16)};

  ${(props) => props.theme.breakpoints.up('sm')} {
    margin-top: ${pxToRem(8)};
    margin-bottom: unset;
  }
`

export const StyledSuccessMessage = styled(Typography)`
  font-size: 15px;
  font-weight: 300;
  line-height: 1.5;
  color: ${(props) => props.theme.palette.text.secondary};
`

export const StyledCooldownText = styled(Typography)`
  font-size: 13px;
  font-weight: 300;
  color: ${(props) => props.theme.palette.text.secondary};
`